export default "__VITE_ASSET__1kyGQ4nr__"